/**
 * Der Erklärtext am Belegbudget-Feld der Reflexionsseite.
 *
 * ACHTUNG, dieses Modul hat am 19.08. seinen ursprünglichen Zweck verloren und
 * heisst nur noch so. Es SCHAETZTE bis dahin, wie viele Zeichen ein Belegbudget
 * dem Meta-Prompt hinzufuegt (zeichenJeBeleg, belegZeichen, BELEG_WARN_ZEICHEN)
 * und warnte ab 12000 Zeichen. Der Warnsatz ist auf Entscheidung Simons
 * gestrichen, und mit ihm die ganze Rechnung: sie zaehlte Zeichen und
 * behauptete damit etwas ueber Token — wie schlecht diese Umrechnung traegt,
 * ist am 18.08. an 25 echten Nachrichten gemessen (2,80 bis 4,76 Zeichen je
 * Token, Faktor 1,70). Eine Rechnung, die niemand mehr abruft, sieht beim
 * naechsten Lesen aus wie eine, deren Anzeige jemand vergessen hat; deshalb
 * faellt sie mit und bleibt nicht als toter Export stehen.
 *
 * Was an dieser Stelle wirklich misst, ist `tokenMessung.js`: gegen das Modell,
 * in Token, auf Knopfdruck.
 *
 * ACHTUNG, die Zahlen stehen NICHT hier. Sie kommen über die Leitung, aus
 * `GET /reflection/optimizer-prompt` → `instruktionen.belegmasse`. Ein Literal
 * in dieser Datei wäre eine zweite Wahrheit, die beim ersten anderen Wert
 * auseinanderliefe — und zwar still, weil einen Tooltip niemand nachrechnet.
 *
 * ACHTUNG, keine Sperre. Wie bei `promptMass`: Sichtbarkeit statt Schranke. Die
 * harte Grenze ist `OPTIMIZER_BELEGBUDGET_MAX` im Eingabefeld und im Schema.
 */

/**
 * Der Erklärtext am Zahlenfeld — kurz, und mit der Zahl, die ohne Eingabe gilt.
 *
 * ACHTUNG, die Standardzahl ist ein ARGUMENT und kein Literal in dieser Datei:
 * sie hängt an OPTIMIZER_MAX_BELEGE und kommt über
 * `instruktionen.belegmasse.max_belege` herein. Eine „drei“ hier wäre eine
 * zweite Wahrheit, die beim ersten anderen Wert auseinanderliefe — und zwar
 * still, weil einen Tooltip niemand nachrechnet. Derselbe Grund, aus dem der
 * frühere Erklärtext unter dem Feld die Zahl nicht ausgeschrieben hat.
 *
 * Fehlt die Angabe, wird die Zahl NICHT geraten — der Satz nennt dann nur, dass
 * die Vorgabe des Optimierers gilt.
 *
 * ACHTUNG, der Vorbehalt zur Sortierung steht seit dem 18.08. hier und nicht
 * mehr als Absatz unter dem Feld: die Diagnosetabelle oben wird OHNE Budget
 * geladen, und ohne den Satz hält jemand sie für das, was der Optimierer
 * sieht. Ein Tooltip ist dafür der richtige Ort — die Auskunft wird gebraucht,
 * wenn jemand das Feld benutzt, und nicht dauerhaft daneben.
 */
export function hilfeBelegbudget(maxBelege) {
  const n = Number(maxBelege);
  const standard = Number.isFinite(n)
    ? `bis zu ${n} Nachrichten aus dem größten Befund`
    : "die Vorgabe des Optimierers";
  return (
    "Wie viele komplette Nachrichten der Optimierer insgesamt im Prompt zu " +
    "sehen bekommt, verteilt nach Relevanz: die Befunde mit den meisten " +
    `Nachrichten zuerst. Leer lassen heißt Standard — ${standard}. ` +
    "Die 0 heißt ausdrücklich: gar keine. Die Diagnosetabelle oben wird " +
    "ohne Budget geladen und ist deshalb womöglich anders sortiert als die " +
    "im Prompt."
  );
}
